module.exports = __webpack_public_path__ + "img/pro-septi.5e8dc5a4.jpeg";